export default "__VITE_ASSET__P9bui9dc__"